import { FormProvider, useForm } from "react-hook-form";
import { defaultProductItem, ProductItem } from "./types.ts";
import { Alert, Box, CircularProgress, Stack } from "@mui/material";
import ProductItemForm from "./ProductItemForm.tsx";
import { useEffect, useState } from "react";
import { useProductItemApi } from "../../hooks/useProductItemApi.ts";
import ProductItemTable from "./ProductItemTable.tsx";
import ConsoleHeader, {
  ConsoleHeaderMeta,
  LedgerFrame,
} from "../../components/common/ConsoleHeader.tsx";
import { designTokens } from "../../theme.ts";

export default function ProductItemMonitor() {
  const methods = useForm<ProductItem>({ defaultValues: defaultProductItem });
  const [data, setData] = useState<ProductItem[]>();
  const [error, setError] = useState<string>();
  const { getAllProductItem } = useProductItemApi();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const json = await getAllProductItem();
        if (!cancelled) setData(json);
      } catch (e: any) {
        if (!cancelled) setError(e.message ?? String(e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const total = data?.length ?? 0;

  return (
    <Box sx={{ fontFamily: designTokens.fonts.sans }}>
      <ConsoleHeader
        code="MARS · STOCK · MONITOR"
        title="제품 모니터"
        meta={<ConsoleHeaderMeta recordCountLabel="등록 제품" count={total} />}
      />

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!data && !error && (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 8 }}>
          <CircularProgress size={28} sx={{ color: designTokens.cargo }} />
          <Box sx={{ fontFamily: designTokens.fonts.sans, fontSize: 14, color: "#6B7178" }}>
            제품 목록을 불러오는 중입니다…
          </Box>
        </Box>
      )}

      {data && (
        <FormProvider {...methods}>
          <Box sx={{ mb: 2.5 }}>
            <ProductItemForm />
          </Box>
          <LedgerFrame label="제품 목록" rows={total}>
            <Stack>
              <ProductItemTable data={data} isLoading={false} />
            </Stack>
          </LedgerFrame>
        </FormProvider>
      )}
    </Box>
  );
}
